import { useTitle } from 'hoofd';

const HoofdTitle = ({ title }) => {
    useTitle(title);
    return null;
};

export default HoofdTitle;
